module.exports = __webpack_public_path__ + "src/class2/img/fire2.383908f5.png";